import { formatDateToDDMMYYYY } from './dateUtils';

export const formatAmount = (val: unknown) =>
  val !== undefined && val !== null && val !== ''
    ? `£${Number(val).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : '£0.00';

export const formatDate = (dateStr: string) => {
  return formatDateToDDMMYYYY(dateStr);
}; 
